import $ from 'jquery'
import { trackMobileLeadSubmitted } from './analytics/marketing-events'

const SUPPORT_MIN_DWELL_MS = 3000
const SUPPORT_COOLDOWN_MS = 45000

function looksLikeGibberish (value) {
  const text = (value || '').trim()

  // Short real names/messages are fine; bot payloads are long random tokens
  if (text.length < 12) {
    return false
  }

  if (/\s/.test(text)) {
    return false
  }

  if (!/^[A-Za-z0-9]+$/.test(text)) {
    return false
  }

  // Mixed case alphanumeric blobs (e.g. pTzSdAUHCyFbgbGlVMZsWe)
  if (/[a-z]/.test(text) && /[A-Z]/.test(text)) {
    return true
  }

  // Long single-case alphanumeric with no spaces is still typical bot junk
  return text.length >= 16
}

function looksLikeDottedGmail (email) {
  const match = (email || '').trim().toLowerCase().match(/^([^@]+)@gmail\.com$/)

  if (!match) {
    return false
  }

  const dots = (match[1].match(/\./g) || []).length
  return dots >= 5
}

function isSupportSpamSubmission ($form, $name, $email, $message) {
  if (($form.find('[name="company_url"]').val() || '').trim()) {
    return true
  }

  const loadedAt = $form.data('px-loaded-at') || 0
  if (Date.now() - loadedAt < SUPPORT_MIN_DWELL_MS) {
    return true
  }

  if (!$form.data('px-interacted')) {
    return true
  }

  if (looksLikeGibberish($name.val()) || looksLikeGibberish($message.val())) {
    return true
  }

  if (looksLikeDottedGmail($email.val())) {
    return true
  }

  const cooldownUntil = $form.data('px-cooldown-until') || 0
  if (Date.now() < cooldownUntil) {
    return true
  }

  return false
}

function showSupportFormSuccess ($form, $submit) {
  $form
    .data('px-submitting', false)
    .data('px-cooldown-until', Date.now() + SUPPORT_COOLDOWN_MS)
    .removeClass('is-submitting')
    .addClass('is-success')

  if ($submit.data('normal-state-value')) {
    $submit.val($submit.data('normal-state-value'))
  }
}

function initSupportFormAntiSpam ($form) {
  if (!$form.length || $form.data('px-antispam-bound')) {
    return
  }

  $form.data('px-antispam-bound', true)
  $form.data('px-loaded-at', Date.now())
  $form.data('px-interacted', false)

  $form.find('#support-name, #support-email, #support-message, #support-category')
    .on('focus.pxantispam input.pxantispam change.pxantispam', function () {
      $form.data('px-interacted', true)
    })
}

function openSupportBeacon () {
  const path = window.location.pathname

  if (typeof window.Beacon !== 'function' || window.__pxSupportBeaconOpenedFor === path) {
    return
  }

  const open = function () {
    if (window.__pxSupportBeaconOpenedFor === path || typeof window.Beacon !== 'function') {
      return
    }

    window.__pxSupportBeaconOpenedFor = path
    window.Beacon('open')

    try {
      window.Beacon('navigate', '/answers/')
    } catch (e) {
      // Older Beacon builds may not support navigate; open alone is enough
    }
  }

  window.Beacon('on', 'ready', open)
  // Fallback if ready already fired before we subscribed
  setTimeout(open, 1200)
}

export function ajaxFormsUpdateDocument() {

  // Support form validation
  $('form.px-validate').on('submit', function (e) {
    var $form = $(this).removeClass('px-validate-failed'),
      $el,
      isValid,
      validationPassed = true;

    // Remove errors from previous form submission
    $form.find('.px-required.error, .styled.error').removeClass('error');

    // Validate
    $form.find('.px-required').each(function (i, el) {
      $el = $(el);

      isValid = $el.val() && ('' !== $el.val().replace(/\s+/g, ''));

      if ('email' === $el.attr('type'))
        isValid = isValid && /^.+?@.+?\..+/.test($el.val());

      if (!isValid) {
        if ($el.is('select')
          && $el.parent().is('.styled')) {
          $el.parent().addClass('error');
        }
        else
          $el.addClass('error');

        validationPassed = false;
      }
    });

    // Interrupt form submission in case we have validation errors
    if (!validationPassed) {
      $form.addClass('px-validate-failed');
      e.preventDefault();
      e.stopPropagation();
    }

    return validationPassed;
  });

  // Support form
  const $supportForm = $('#supportContactForm')
  if ($supportForm.length) {
    initSupportFormAntiSpam($supportForm)
    openSupportBeacon()
  }

  $('form.ajax_form').on('submit', function (e) {
    e.preventDefault();

    let $form = $(e.target);
    let $category = $('#support-category');
    let $name = $('#support-name');
    let $email = $('#support-email');
    let $message = $('#support-message');
    let $submit = $form.find('.support-contact-submit');

    // Do not submit form if it is being submitted
    if ($form.data('px-submitting'))
      return;

    // Do not submit form if it has failed validation
    if ($form.is('.px-validate-failed'))
      return;

    // Frontend anti-spam: fake success and skip GraphQL
    if ($form.is('#supportContactForm') && isSupportSpamSubmission($form, $name, $email, $message)) {
      if ($submit.data('sending-value') && !$submit.data('normal-state-value')) {
        $submit.data('normal-state-value', $submit.val());
      }
      showSupportFormSuccess($form, $submit);
      return;
    }

    // Remove errors from previous form submission
    $form.data('px-submitting', true).removeClass('is-error').removeClass('is-sending-error').addClass('is-submitting');
    $form.find('.px-required.error, .styled.error').removeClass('error');

    // Set the loading state
    if ($submit.data('sending-value')) {
      if (!$submit.data('normal-state-value'))
        $submit.data('normal-state-value', $submit.val());

      $category.attr('disabled', 'disabled');
      $name.attr('disabled', 'disabled');
      $email.attr('disabled', 'disabled');
      $message.attr('disabled', 'disabled');
      $submit.val($submit.data('sending-value'));
    }

    // Send request
    $.ajax({
      url: $form.attr('action'),
      method: 'POST',
      contentType: 'application/json',
      headers: {
        'apollographql-client-name': window.px_config.pxApi.client.id,
        'apollographql-client-version': window.px_config.pxApi.client.version
      },
      data: JSON.stringify({
        query: `
          mutation SendSupportEmail($input: CustomerSupportEmailInput!) {
            sendEmailCustomerSupport(input: $input) {
              status
            }
          }
        `,
        variables: {
          input: {
            category: $category.val(),
            customerName: $name.val(),
            customerEmail: $email.val(),
            message: $message.val()
          }
        }
      }),
      success: function(response) {
        if (response.data.sendEmailCustomerSupport && response.data.sendEmailCustomerSupport.status && response.data.sendEmailCustomerSupport.status === "ENQUEUED") {
          showSupportFormSuccess($form, $submit);
        } else {
          $submit.val($submit.data('normal-state-value'));
          $form.data('px-submitting', false).removeClass('is-submitting').addClass('is-error is-sending-error');
        }
      },
      error: function() {
        $submit.val($submit.data('normal-state-value'));
        $form.data('px-submitting', false).removeClass('is-submitting').addClass('is-error is-sending-error');
      }
    });
  });

  // SmartAlbums Mobile Trial Download Sign Up form
  if ($('[data-form_type="mobile_trial_download_sign_up"]').length > 0) {
    let $form = $('[data-form_type="mobile_trial_download_sign_up"]');
    let $input = $form.find('input[type="email"]');
    let $button = $form.find('button');
    let $container = ($form.closest('.trial-download-info').length !== 0) ? $form.closest('.trial-download-info') : $form.closest('.sa-mobile-download');

    let reg_email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    // Remove the "wrong" style of the input
    $input.on('keydown.pxtrigger', function () {
      $input.removeClass('-wrong');
    });

    $form.on('submit.pxtrigger', function (e) {
      e.preventDefault();
    });

    $button.on('click.pxtrigger', function (e) {
      e.preventDefault();

      // Wrong value
      if (reg_email.test($input.val()) === false)
        $input.addClass('-wrong').trigger('focus');

      // Sending
      else {
        $container.addClass('-loading');

        $.ajax({
          url: $form.attr('data-action'),
          method: 'POST',
          contentType: 'application/json',
          headers: {
            'apollographql-client-name': window.px_config.pxApi.client.id,
            'apollographql-client-version': window.px_config.pxApi.client.version
          },
          data: JSON.stringify({
            query: `
              mutation BlogSubscribe($input: MailChimpSubscribeToListInput!) {
                subscribeToMailchimpList(input: $input) {
                  status
                }
              }
            `,
            variables: {
              input: {
                email: $input.val(),
                locale: $('html').attr('lang'),
                list: "TRIAL"
              }
            }
          }),
          success: function (response) {
            // Success
            if (response.data.subscribeToMailchimpList.status && response.data.subscribeToMailchimpList.status === "subscribed") {
              $container.removeClass('-loading').addClass('-success');
              trackMobileLeadSubmitted();
            }

            // Fields error
            else
              $container.removeClass('-loading').addClass('-error');
          },
          error: function () {
            // Backend error
            $container.removeClass('-loading').addClass('-error');
          }
        });
      }
    });
  }

}
